import React from 'react';
import { Box } from '@chakra-ui/react';
import { AUTO_DETECT_MAPPING } from '../../constants/autoDetectMapping';

const DetectionBoxes = ({
  detections,
  showBoundingBoxes = true,
  visibleFeatures = {}
}) => {
console.log('[DetectionBoxes] Props received - detections:', JSON.stringify(detections, null, 2), 'showBoundingBoxes:', showBoundingBoxes, 'visibleFeatures:', visibleFeatures);
  // Skip rendering if no detections or bounding boxes are hidden
  if (!detections || detections.length === 0 || !showBoundingBoxes) return null;
  
  // Skip rendering if image dimensions are not valid

  return (
    <>
      {detections.map((d, i) => {
        // Check if this feature should be visible
        const isVisible = visibleFeatures[d.class] !== false;
        if (!isVisible) return null;

        // Ensure coordinates are valid numbers
        const x = typeof d.x === 'number' ? d.x : 0;
        const y = typeof d.y === 'number' ? d.y : 0;
        const w = typeof d.width === 'number' ? d.width : 0;
        const h = typeof d.height === 'number' ? d.height : 0;

        // Format display label
        const displayLabel = d.class.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

        return (
          <Box
            key={i}
            position="absolute"
            top={`${y * 100}%`}
            left={`${x * 100}%`}
            width={`${w * 100}%`}
            height={`${h * 100}%`}
            transform="translate(-50%, -50%)"
            borderWidth="2px" // Use theme token implicitly
            borderStyle="solid"
            borderColor="brand.primary" // Use theme token
            backgroundColor="transparent"
            pointerEvents="none"
            zIndex={2}
          >
            <Box
              position="absolute"
              top="-24px"
              left="50%"
              transform="translateX(-50%)"
              bg="brand.primary" // Use theme token
              color="whiteAlpha.900" // Use theme token for contrast
              px="2"
              py="1"
              borderRadius="md"
              fontSize={{ base: '2xs', md: 'xs' }} // Responsive font
              fontWeight="bold"
              zIndex={3}
              whiteSpace="nowrap"
            >
              #{i+1} {displayLabel} {d.confidence && `(${Math.round(d.confidence * 100)}%)`}
            </Box>
          </Box>
        );
      })}
    </>
  );
};

export default DetectionBoxes;